/**
 * Audio upload eligibility matches API enforcement in media_limits.validate_audio_upload:
 * free tier has audio_max_size_mb === 0 (no uploads). Starter+ may upload per tier caps.
 */
export function canUploadAudioByTier(tier: string): boolean {
  return tier.toLowerCase() !== 'free';
}
